import React from 'react';

const Input = ({name, label, error, ...rest}) => { // ...rest captures the other attribues passed
    return  <div className="form-group">
    <label htmlFor={name}>{label}</label>
    <input 
    {...rest}  
    name={name}   
     id={name} className="form-control"/>
    {error &&<div className="validation-message">{error}</div>}
    </div> ;
}

const TextArea = ({ name, label, error, ...rest }) => { // ...rest captures the other attribues passed
  return <div className="form-group">
           <label htmlFor={name}>{label}</label>
           <textarea
             {...rest}
             name={name}
              id={name} className="form-control" />
           {error && <div className="validation-message">{error}</div>}
         </div>;
}

export { Input, TextArea }